(function () {
  'use strict';

  var previousOwner = window.IntegyV521GlobalOwner;
  if (previousOwner && typeof previousOwner.destroy === 'function') previousOwner.destroy();

  var navObserver = null;
  var modalObserver = null;
  var sectionLoadHandler = null;
  var sectionUnloadHandler = null;
  var responsiveImageTimer = null;
  var responsiveImageResizeHandler = null;
  var responsiveImagePageShowHandler = null;

  function bindMobileNavigationState() {
    if (navObserver) navObserver.disconnect();
    navObserver = null;

    var nav = document.querySelector('[data-mobile-nav]');
    var toggle = document.querySelector('[data-menu-toggle]');
    if (!nav || !toggle) return;

    if (!nav.id) nav.id = 'site-mobile-nav';
    nav.setAttribute('role', 'dialog');
    nav.setAttribute('aria-modal', 'true');
    nav.setAttribute('aria-label', 'Main navigation');
    toggle.setAttribute('aria-controls', nav.id);

    function sync() {
      toggle.setAttribute('aria-expanded', nav.getAttribute('data-open') === 'true' ? 'true' : 'false');
    }

    sync();
    navObserver = new MutationObserver(sync);
    navObserver.observe(nav, { attributes: true, attributeFilter: ['data-open'] });
  }

  function labelQuickShopDialogs(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var dialogs = Array.prototype.slice.call(root.querySelectorAll('.modal--quickshop-full'));
    if (root.matches && root.matches('.modal--quickshop-full')) dialogs.unshift(root);
    dialogs.forEach(function (dialog) {
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      if (!dialog.getAttribute('aria-label') && !dialog.getAttribute('aria-labelledby')) {
        dialog.setAttribute('aria-label', 'Quick shop');
      }
    });
  }

  function repairNullResponsiveImages(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var images = Array.prototype.slice.call(root.querySelectorAll('img[srcset="null"]'));
    if (root.matches && root.matches('img[srcset="null"]')) images.unshift(root);

    images.forEach(function (image) {
      if (String(image.getAttribute('srcset') || '').trim().toLowerCase() !== 'null') return;
      image.removeAttribute('srcset');
    });
  }

  function scheduleResponsiveImageRepair() {
    window.clearTimeout(responsiveImageTimer);
    responsiveImageTimer = window.setTimeout(function () {
      responsiveImageTimer = null;
      repairNullResponsiveImages(document);
    }, 120);
  }

  function destroy() {
    if (navObserver) navObserver.disconnect();
    navObserver = null;
    if (modalObserver) modalObserver.disconnect();
    modalObserver = null;
    if (sectionLoadHandler) document.removeEventListener('shopify:section:load', sectionLoadHandler);
    if (sectionUnloadHandler) document.removeEventListener('shopify:section:unload', sectionUnloadHandler);
    if (responsiveImageResizeHandler) {
      window.removeEventListener('resize', responsiveImageResizeHandler);
      window.removeEventListener('orientationchange', responsiveImageResizeHandler);
    }
    if (responsiveImagePageShowHandler) window.removeEventListener('pageshow', responsiveImagePageShowHandler);
    window.clearTimeout(responsiveImageTimer);
    responsiveImageTimer = null;
    responsiveImageResizeHandler = null;
    responsiveImagePageShowHandler = null;
    sectionLoadHandler = null;
    sectionUnloadHandler = null;
  }

  function init() {
    bindMobileNavigationState();
    labelQuickShopDialogs(document);
    repairNullResponsiveImages(document);
    if (document.body && window.MutationObserver) {
      modalObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'srcset') {
            repairNullResponsiveImages(mutation.target);
            return;
          }
          Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
            if (node && node.nodeType === 1) {
              labelQuickShopDialogs(node);
              repairNullResponsiveImages(node);
            }
          });
        });
      });
      modalObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['srcset']
      });
    }
    responsiveImageResizeHandler = scheduleResponsiveImageRepair;
    responsiveImagePageShowHandler = scheduleResponsiveImageRepair;
    window.addEventListener('resize', responsiveImageResizeHandler, { passive: true });
    window.addEventListener('orientationchange', responsiveImageResizeHandler, { passive: true });
    window.addEventListener('pageshow', responsiveImagePageShowHandler);
    sectionLoadHandler = function (event) {
      if (event.target && event.target.querySelector && event.target.querySelector('[data-mobile-nav]')) {
        bindMobileNavigationState();
      }
      repairNullResponsiveImages(event.target || document);
    };
    document.addEventListener('shopify:section:load', sectionLoadHandler);
    sectionUnloadHandler = function (event) {
      if (event.target && event.target.querySelector && event.target.querySelector('[data-mobile-nav]') && navObserver) {
        navObserver.disconnect();
        navObserver = null;
      }
    };
    document.addEventListener('shopify:section:unload', sectionUnloadHandler);
  }

  window.IntegyV521GlobalOwner = {
    bindMobileNavigationState: bindMobileNavigationState,
    labelQuickShopDialogs: labelQuickShopDialogs,
    repairNullResponsiveImages: repairNullResponsiveImages,
    destroy: destroy
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
